import { Controller } from '@organisms';
import { Col, Flex, Row, Typography } from 'antd';
import { FC } from 'react';
import { Control } from 'react-hook-form';

import { OfferFormData } from '../../../interfaces/offersInterface';

interface FormAnalyticsProps {
  control: Control<OfferFormData>;
}

export const FormAnalytics: FC<FormAnalyticsProps> = ({
  control,
}: FormAnalyticsProps) => {
  return (
    <Flex vertical>
      <Row style={{ gap: '24px' }}>
        <Col style={{ flex: 1 }}>
          <Controller
            control={control}
            name={`analytics.googleAnalyticsIds`}
            defaultValue={''}
            placeholder='Cole a UA aqui'
            autoComplete='off'
            label='Google analytics'
            required
            tooltip={{
              title: () => (
                <Typography.Text>
                  Dica: Insira valores no formato UA-65884289-2, separando
                  múltiplos valores adicionais com vírgulas.
                </Typography.Text>
              ),
            }}
          />
        </Col>
        <Col style={{ flex: 1 }}>
          <Controller
            control={control}
            name={`analytics.facebookPixels`}
            defaultValue={''}
            placeholder='Cole o ID aqui'
            autoComplete='off'
            label='Facebook Pixel'
            required
            tooltip={{
              title: () => (
                <Typography.Text>
                  Dica: Insira valores no formato Pixel ID 65884289-2, separando
                  múltiplos valores adicionais com vírgulas.
                </Typography.Text>
              ),
            }}
          />
        </Col>
      </Row>
    </Flex>
  );
};
